export default __webpack_public_path__ + "media/images/plans/holding_hands-3dbc2d18beb61d855ba0f64ca5419f6e.png";